export default __webpack_public_path__ + "static/media/line.5609155c.svg";